// extracted by mini-css-extract-plugin
export default {"errcontainer":"Error_errcontainer__KN9Dm","err":"Error_err__+MFN9"};